import { render, staticRenderFns } from "./CznUserInfo.vue?vue&type=template&id=07094950"
import script from "./CznUserInfo.vue?vue&type=script&lang=js"
export * from "./CznUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports